import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Stack } from '@mui/material';
import { EventProduct, GetProductsResItem0RouteDto } from '@travelity/api';

import { SingleLineKeyValue } from '../booking-participants/components/single-line-key-value';
import { Route } from '../route';

export interface BookingProductFormProps {
    product: EventProduct;
    route?: GetProductsResItem0RouteDto;
    preview?: boolean;
}

const BookingProductForm: React.FC<BookingProductFormProps> = ({
    preview,
    product,
    route,
}) => {
    const { t } = useTranslation('product');
    const { name, type } = product;

    const routes = useMemo(
        () => route?.items?.map(stop => ({ name: stop.location.name })) || [],
        [route]
    );

    // @ts-ignore
    return preview ? (
        <Stack spacing={2}>
            <SingleLineKeyValue
                dark
                label={t('Type', { ns: 'booking' })}
                value={t(type)}
            />
            <Divider />
            <SingleLineKeyValue
                dark
                label={t('Name', { ns: 'booking' })}
                value={name}
            />
            <Divider>{t('Route')}</Divider>
            <Route
                color="grey"
                stops={routes}
                timelineProps={{
                    sx: { pl: '2px' },
                }}
            />
        </Stack>
    ) : (
        <Stack spacing={3} />
    );
};

export default React.memo(BookingProductForm);
